import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Installer from "./pages/installer";
import About from "./pages/about";
import Terms from "./pages/terms";


const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/installer" element={<Installer />} />
      </Routes>
    </Router>
  )
}

export default App;